import { useQuery } from '@apollo/client/react';

import { GeocodeDocument } from '@graphql/platform';

import { useLastDefined } from '@utils/hooks/use_last_defined';

/**
 * Disposal eligibility for the current ZIP.
 * While a new ZIP geocode is in flight, keep the last known result so checkout
 * does not briefly treat the ZIP as ineligible (which unmounts the disposal
 * step and clears the customer's selection).
 */
export function useEligibleForDisposalZIP(zip?: string): boolean {
  const { data, loading, error } = useQuery(GeocodeDocument, {
    variables: { zip: zip ?? '' },
    skip: !zip,
  });

  const eligibility = data ? !!data.geocode?.eligibleForDisposal : undefined;
  const lastEligibility = useLastDefined(
    zip && !error && loading ? undefined : eligibility,
  );

  if (!zip || error) {
    return false;
  }

  if (loading) {
    return lastEligibility ?? false;
  }

  return eligibility ?? false;
}
